// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/img/dust_scratches.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#vod-content
/*всё поле*/ {
  margin-left: 2vw;
  margin-right: 2vw;
  display: grid;
  padding: 0.2% 0.6% 0.3%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  box-shadow:
    0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  min-height: 100vh;
  width: auto;
}
.vod-conteiner {
  display: grid;
  grid-template-rows: auto auto 1fr;
  align-items: start;
  height: 100%;
}

.vod-mainsubtitle {
  display: grid;
  justify-self: center;
  width: 17vw;
}
.vod-Logo-name {
  display: grid;
      grid-template-columns: 10vw 63vw 21.8vw;
  height: 1vw;
  z-index: 1;
}
.vod-logo {
  height: 3.4vw;
  place-items: start;
}
.vod-fullscreen {
      display: grid;
    height: 1.5vw;
    justify-self: end;
    position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Vodyanoy/styles/App.css"],"names":[],"mappings":"AAAA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,yDAAgE;EAChE;;oCAEkC;EAClC,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,aAAa;MACT,uCAAuC;EAC3C,WAAW;EACX,UAAU;AACZ;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;MACM,aAAa;IACf,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":["#vod-content\n/*всё поле*/ {\n  margin-left: 2vw;\n  margin-right: 2vw;\n  display: grid;\n  padding: 0.2% 0.6% 0.3%;\n  background-image: url(../../../../public/img/dust_scratches.png);\n  box-shadow:\n    0 4px 8px 0 rgba(0, 0, 0, 0.2),\n    0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  min-height: 100vh;\n  width: auto;\n}\n.vod-conteiner {\n  display: grid;\n  grid-template-rows: auto auto 1fr;\n  align-items: start;\n  height: 100%;\n}\n\n.vod-mainsubtitle {\n  display: grid;\n  justify-self: center;\n  width: 17vw;\n}\n.vod-Logo-name {\n  display: grid;\n      grid-template-columns: 10vw 63vw 21.8vw;\n  height: 1vw;\n  z-index: 1;\n}\n.vod-logo {\n  height: 3.4vw;\n  place-items: start;\n}\n.vod-fullscreen {\n      display: grid;\n    height: 1.5vw;\n    justify-self: end;\n    position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
